import { LocationProjectionStore } from './store'

export * from './store'
export const locationStore = LocationProjectionStore.new()
